export default "__VITE_ASSET__rbD7DxlO__"